import camelcaseKeys from 'camelcase-keys'

export class Account {
  constructor (params = {}) {
    const { account, currencies } = params ? camelcaseKeys(params) : {}
    this.id = account.id
    this.active = account.active
    this.pricingGroupId = account.pricing_group_id ? account.pricing_group_id : null
    this.currencies = currencies.map((item) => {
      return new Currency(item)
    })
  }
}
export class Currency {
  constructor (params = {}) {
    const { balance, currency, postpaid } = params ? camelcaseKeys(params) : {}
    this.id = currency.id
    this.name = currency.name
    this.type = currency.type
    this.balance = balance
    this.postPaid = postpaid
  }
}
